// "Évoli" -> "evoli", "Mr. Mime" -> "mrmime", "Farfetch’d" -> "farfetchd",
// and German "ß" -> "ss"
export function normalizeSearch(text) {
  return text
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/ß/g, "ss")
    .replace(/[ \-.'":’]/g, "");
}
